"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Theme = require("../Theme");
var _base = require("./base");
var _SvgIconsMap = _interopRequireDefault(require("./SvgIconsMap"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var light = {
  mode: _Theme.ThemeMode.light,
  colors: _objectSpread(_objectSpread({}, _base.kwikySharedColors), {}, {
    themeBase: "#ffffff",
    pageBackground: "linear-gradient(to bottom, #30073b 0%, #060d2f 100%)",
    baseContrast010: "#fafafa",
    baseContrast015: "#eeeeee",
    baseContrast020: "#eeeeee",
    baseContrast030: "#e0e0e0",
    baseContrast040: "#bdbdbd",
    baseContrast050: "#9e9e9e",
    baseContrast060: "#757575",
    baseContrast070: "#585858",
    baseContrast080: "#424242",
    baseContrast085: "#313131",
    baseContrast090: "#212121",
    baseContrast100: "#000000"
  }),
  iconSizes: _base.kwikyIconSizes,
  spacing: _base.kwikySpacing,
  typography: _base.kwikyTypography,
  components: _base.kwikyComponents,
  isAlwaysNativeDropDownMenu: _base.isAlwaysNativeDropDownMenu,
  svgIconsMapOverrides: _SvgIconsMap.default
};
var _default = exports.default = light;